import axios from 'axios';
import _ from 'lodash';

import { isAlertExempted, sendSlackAlert } from './slack';

const accessKey = 'accessToken';
const profile = 'userProfile';
const isSSOLogin = 'isSSOLogin';

const environments = [
  {
    name: 'dev',
    env: 'https://adt-dev.mobilelive.ca',
    apiHost: 'https://d3qv35y8tvum1q.cloudfront.net',
    sof1ApiHost: 'https://d19gw23pzxczol.cloudfront.net/api',
    sof2ApiHost: 'https://d1nd2761nfgm51.cloudfront.net/api'
  },
  {
    name: 'qa',
    env: 'https://adt-qa.myorderdashboard.com',
    apiHost: 'https://d29z4n2gpqoeqt.cloudfront.net',
    sof1ApiHost: 'https://d1qn0cvskl90yh.cloudfront.net/api',
    sof2ApiHost: 'https://d3qod0vpxxf6jc.cloudfront.net/api'
  },
  {
    name: 'prod',
    env: 'https://www.myorderdashboard.com',
    apiHost: 'https://d2mcrq783vsnc2.cloudfront.net',
    sof1ApiHost: 'https://d392300n61qa5s.cloudfront.net/api',
    sof2ApiHost: 'https://d36u5buucu9rtz.cloudfront.net/api'
  }
];

export const getEnvironment = () => {
  const currentEnvironment = environments.find(
    environment => window.location.origin === environment.env
  );
  return currentEnvironment || environments[0];
};

const getApiHost = () => {
  const currentEnvironment = getEnvironment();
  return currentEnvironment.apiHost;
};

const getSOF1ApiHost = () => {
  const currentEnvironment = getEnvironment();
  return currentEnvironment.sof1ApiHost;
};

const getSOF2ApiHost = () => {
  const currentEnvironment = getEnvironment();
  return currentEnvironment.sof2ApiHost;
};

export const apiHost = getApiHost();
export const sof1ApiHost = getSOF1ApiHost();
export const sof2ApiHost = getSOF2ApiHost();

export const config = () => {
  return {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(accessKey)}`,
      'Access-Control-Allow-Origin': '*',
      locale: localStorage.getItem('locale')
    }
  };
};

axios.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    const { name: envName } = getEnvironment();
    const userProfile = JSON.parse(localStorage.getItem(profile));
    if (!isAlertExempted(error.response)) {
      await sendSlackAlert(
        {
          ...error.response,
          email: _.get(userProfile, 'email', '')
        },
        envName
      );
    }
    if (error.response && error.response.status === 403) {
      localStorage.clear();
      window.location.pathname = '/login';
    } else {
      throw error;
    }
  }
);

const request = {
  setToken: token => {
    localStorage.setItem(accessKey, token);
  },
  setProfile: value => {
    localStorage.setItem(profile, JSON.stringify(value));
  },
  setSSOLoginState: value => {
    localStorage.setItem(isSSOLogin, value);
  },
  getToken: () => {
    return localStorage.getItem(accessKey);
  },
  getProfile: () => {
    return JSON.parse(localStorage.getItem(profile));
  },
  getSSOLoginState: () => {
    const data = localStorage.getItem(isSSOLogin);
    return data ? JSON.parse(data) : false;
  },
  get: url => {
    return axios.get(`${apiHost}${url}`, config());
  },
  post: (url, body) => {
    return axios.post(`${apiHost}${url}`, body, config());
  },
  put: (url, body) => {
    return axios.put(`${apiHost}${url}`, body, config());
  }
};

export const USER_RIGHTS = {
  ADMIN: {
    isStatusEditable: true,
    isInstallationDateEditable: true,
    isUserEditable: true,
    isUserPageVisible: true,
    canAssignOrder: true,
    isEcidEditable: true,
    canAssignOrderBack: false,
    isBulkUploadVisible: true
  },
  SALES_REP: {
    isStatusEditable: false,
    isInstallationDateEditable: false,
    isUserEditable: false,
    isUserPageVisible: false,
    isEcidEditable: true,
    canAssignOrderBack: true,
    canAssignOrder: false
  },
  SALES_MANAGER: {
    isStatusEditable: false,
    isInstallationDateEditable: false,
    isUserEditable: false,
    isUserPageVisible: false,
    isEcidEditable: true,
    canAssignOrderBack: true,
    canAssignOrder: false
  },
  SALES_SUPPORT: {
    isStatusEditable: true,
    isInstallationDateEditable: true,
    isUserEditable: true,
    isUserPageVisible: false,
    isEcidEditable: true,
    canAssignOrderBack: false,
    canAssignOrder: true
  },
  ORDER_FULFILLMENT: {
    isStatusEditable: true,
    isInstallationDateEditable: true,
    isUserEditable: true,
    isUserPageVisible: false,
    isEcidEditable: false,
    canAssignOrderBack: false,
    canAssignOrder: true
  }
};

export default request;
